import { useDatoClient } from '@src/stores-v2/StoreContext';
import { useMemo } from 'react';

import { ContentAutosaveService } from '../services/ContentAutosaveService';

/**
 * DI hook for the Content (Blog / Social Post / Email) autosave service.
 *
 * Memoized per `storyRepository` identity so re-renders don't churn a new
 * service instance. View components call this instead of constructing the
 * service directly, per CLAUDE.md's "Components \u2014 useXService() hooks
 * for DI, never `new Service()`" rule.
 */
export function useContentAutosaveService(): ContentAutosaveService {
  const datoClientStore = useDatoClient();
  return useMemo(
    () => new ContentAutosaveService(datoClientStore.storyRepository),
    [datoClientStore.storyRepository],
  );
}
